/**
 * React-facing access to the backend client.
 *
 * The client (utils/api_client.js) reads its token straight from the Keycloak
 * singleton, so it needs nothing from React to work — this hook exists only so
 * components follow one consistent idiom (useApi() alongside useAuth(), etc.)
 * and get a stable reference safe to list in useEffect deps.
 *
 *   const api = useApi();
 *   useEffect(() => {
 *     api.get('/api/entities', { params: { entity_type: 'person', user_id } })
 *        .then(setPeople)
 *        .catch(() => message.error('Could not load people'));
 *   }, [api, user_id]);
 */

import api from '../utils/api_client';

export function useApi() {
    return api; // module-level singleton — already stable across renders
}

export default useApi;
